<template>
  <section id="container" class="efs_ds">
    <div>
      <div class="title_wrap">
        <div class="f_r" style="text-align: right; font-size:23px;">
          <button class="large_btn orange"
                  @click="commonOnChangeEvent"
                  style="width:100px; float:right; margin-left:10px; margin-bottom:10px;"
          >새로고침
          </button>
          {{ lastRenderingTime }}
          <kendo-switch
              ref="autoYnRef"
              :messages-checked="'자동'"
              :messages-unchecked="'수동'"
              :checked="autoRender"
              @change="setAutoRender"
          >
          </kendo-switch>
        </div>
        <h1>키오스크 접수 현황</h1>
      </div>
      <div class="contents_wrap">
      <div class="box_flex w85">
        <div class="k-widget k-daterangepicker k-state-default w40" data-role="daterangepicker" role="combobox" aria-expanded="false" autocomplete="off">
          <kendo-datepicker
              ref="frstRgstDtStartDtRef"
              :max="maxDate"
              :placeholder="'년/월/일'"
              :format="'yyyy/MM/dd'"
              :value="lastRouteParams.frstRgstDtStartDt"
              @change="commonOnChangeEvent"
          >
          </kendo-datepicker>
          <span>&nbsp;</span>
          <kendo-datepicker
              ref="frstRgstDtEndDtRef"
              :max="maxDate"
              :placeholder="'년/월/일'"
              :format="'yyyy/MM/dd'"
              :value="lastRouteParams.frstRgstDtEndDt"
              @change="commonOnChangeEvent"
          >
          </kendo-datepicker>
        </div>
        <div class="w20">
        <kendo-dropdownlist
            ref="facilityRef"
            :option-label="'전체'"
            class="w100"
            @change="onChangeFacility"
            :data-source="zone1DepthList"
            :data-text-field="'cdNm'"
            :data-value-field="'cdId'"
            :value="lastRouteParams.facility"
            :no-data-template="'표시할 데이터가 없습니다.'"
        >
        </kendo-dropdownlist>
        </div>
        <div class="w20">
        <kendo-multiselect
            ref="areaRef"
            class="w100"
            :placeholder="'거점'"
            :data-source="zone2DepthList"
            :data-text-field="'cdNm'"
            :data-value-field="'cdId'"
            :tag-mode="'single'"
            :filter="'contains'"
            :value="lastRouteParams.areaList"
            :auto-close="false"
            @change="onChangeArea"
            :no-data-template="'표시할 데이터가 없습니다.'"
            :tag-template="`<span class='k-input'>#:values.length# 거점 선택됨 </span>`"
        >
        </kendo-multiselect>
        </div>
        <div class="w20">
        <kendo-maskedtextbox
            class="w100"
            ref="steadNmRef"
            id="steadNm"
            :placeholder="'수령인/발송인'"
            :value="lastRouteParams.steadNm"
        >
        </kendo-maskedtextbox>
        </div>
      </div>
      <div class="button_wrap_area">
        <ul>
          <li>
      <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
          </li>
          <li>
      <button class="large_btn mgl10" @click="clearFilter">초기화</button>
          </li>
        </ul>
      </div>
      <ul class="list_company">
        <li v-for="item in searchAreaTextList"> {{ item.cdNm }} <span class="k-icon k-i-close"></span></li>
      </ul>
      </div>
    </div>
    <div class="mt20 esai_cmdp_tab">
      <h3 class="f_r">총 개수 : {{ totalCount }}</h3>
      <kendo-tabstrip
          :value="computedTabSearch"
      >
        <ul>
          <li v-for="item in tabSearchData"
              @click="onChangeTab(item)">{{ item }}</li>
        </ul>
      </kendo-tabstrip>
      <div v-if="totalCount > 0" class="tab-content">
        <div>
          <ol class="cmdp_box_list">

            <div @click="redirectToDetail(item.sendReceiveGbn, item.sendReceiveId)" class="esai_contents_wrap" v-for="(item) in receptionStatusList" style="cursor:pointer;">
              <!-- 완료 상태 아닌 것 -->
              <li v-if="item.status !== '99'">
                <!-- 수령 -->
                <div v-if="item.sendReceiveGbn === '수령'" class="cmdp_kiosk_box_top kiosk_receipt">
                  <ul>
                    <li>{{ item.sendReceiveGbn }}<span class="f_l">{{ item.itemId }}</span></li>
                    <li>
                      <img v-if="item.scn === '08'" src="@/assets/img/etners-web/cmdp_receipt_ic03.png" alt="" class="mr5">
                      <img v-if="(item.scn === '01' || item.scn === '02' || item.scn === '03' || item.scn === '04' || item.scn === '05' || item.scn === '06' || item.scn === '07') " src="@/assets/img/etners-web/cmdp_receipt_ic02.png" alt="" class="mr5">
                      <img v-if="item.scn === '09'" src="@/assets/img/etners-web/cmdp_receipt_ic01.png" alt="" class="mr5">{{ item.scnNm }}<span class="f_r"><span class="txt_s">받는분 :</span>{{ item.receiveNm ? item.receiveNm : '-' }}</span>
                    </li>
                    <li class="f_r">{{ item.frstRgstDt}}</li>
                  </ul>
                </div>
                <div v-if="item.sendReceiveGbn === '수령'" class="cmdp_kiosk_box_middle">
                  <table class="w100">
                    <colgroup>
                      <col width="20%">
                    </colgroup>
                    <tr>
                      <th class="w30">BL No.</th>
                      <td>{{ item.blNo ? item.blNo : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">특송사</th>
                      <td>{{ item.shpcScn ? item.shpcScn : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">부서</th>
                      <td><span>{{ item.receiveDept ? item.receiveDept : '-' }}</span></td>
                    </tr>
                    <!-- <tr>
                      <th class="w30">진행 상태</th>
                      <td><span>{{ item.statusNm ? item.statusNm : '-' }}</span></td>
                    </tr> -->
                    <tr>
                      <th class="w30">보내는 분</th>
                      <td>{{ item.sendNm ? item.sendNm : '-' }}</td>
                    </tr>
                  </table>
                </div>

                <!-- 발송 -->
                <div v-if="item.sendReceiveGbn === '발송'" class="cmdp_kiosk_box_top kiosk_send">
                  <ul>
                    <li>{{ item.sendReceiveGbn }}<span class="f_l">{{ item.itemId }}</span></li>
                    <li>
                      <img v-if="item.scnNm === '택배'" src="@/assets/img/etners-web/cmdp_send_ic03.png" alt="" class="mr5">
                      <img v-if="item.scnNm === '등기'" src="@/assets/img/etners-web/cmdp_send_ic02.png" alt="" class="mr5">
                      <img v-if="item.scnNm === '해외특송'" src="@/assets/img/etners-web/cmdp_send_ic01.png" alt="" class="mr5">{{ item.scnNm }}
                      <span class="f_r"><span class="txt_s">보내는분 :</span> {{ item.sendNm ? item.sendNm : '-' }}</span>
                    </li>
                    <li class="f_r">{{ item.frstRgstDt}}</li>
                  </ul>
                </div>
                <div v-if="item.sendReceiveGbn == '발송'" class="cmdp_kiosk_box_middle">
                  <table class="w100">
                    <colgroup>
                      <col width="20%">
                    </colgroup>
                    <tr>
                      <th class="w30">BL No.</th>
                      <td>{{ item.blNo ? item.blNo : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">특송사</th>
                      <td>{{ item.shpcScn ? item.shpcScn : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">부서</th>
                      <td><span>{{ item.steadDept ? item.steadDept : '-' }}</span></td>
                    </tr>
                    <!-- <tr>
                      <th class="w30">진행 상태</th>
                      <td><span>{{ item.statusNm ? item.statusNm : '-' }}</span></td>
                    </tr> -->
                    <tr>
                      <th class="w30">받는 분</th>
                      <td>{{ item.receiveNm ? item.receiveNm : '-' }}</td>
                    </tr>
                  </table>
                </div>
              </li>

              <!-- 완료 상태인 것 -->
              <li v-else style="background: #ccc; height:100%">
                <div class="cmdp_kiosk_box_top kiosk_finish">
                  <ul>
                    <li> {{ item.sendReceiveGbn }} 완료 <span class="f_l">{{ item.itemId }}</span></li>
                    <li><img src="@/assets/img/etners-web/cmdp_receipt_ic01.png" alt="" class="mr5">{{ item.scnNm }}<span class="f_r"><span class="txt_s">받는 분 :</span>{{ item.steadNm ? item.steadNm : '-' }}</span></li>
                    <li class="f_r">{{ item.frstRgstDt}} </li>
                  </ul>
                </div>

                <!-- 수령 -->
                <div v-if="item.sendReceiveGbn === '수령'" class="cmdp_kiosk_box_middle">
                  <table class="w100">
                    <colgroup>
                      <col width="20%">
                    </colgroup>
                    <tr>
                      <th class="w30">BL No.</th>
                      <td>{{ item.blNo ? item.blNo : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">특송사</th>
                      <td>{{ item.shpcScn ? item.shpcScn : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">부서</th>
                      <td><span>{{ item.receiveDept ? item.receiveDept : '-' }}</span></td>
                    </tr>
                    <tr>
                      <th class="w30">보내는 분</th>
                      <td>{{ item.sendNm ? item.sendNm : '-' }}</td>
                    </tr>
                  </table>
                </div>
                <!-- 발송 -->
                <div v-if="item.sendReceiveGbn == '발송'" class="cmdp_kiosk_box_middle">
                  <table class="w100">
                    <colgroup>
                      <col width="20%">
                    </colgroup>
                    <tr>
                      <th class="w30">BL No.</th>
                      <td>{{ item.blNo ? item.blNo : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">특송사</th>
                      <td>{{ item.shpcScn ? item.shpcScn : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">받는 분</th>
                      <td>{{ item.sendNm ? item.sendNm : '-' }}</td>
                    </tr>
                    <tr>
                      <th class="w30">부서</th>
                      <td><span>{{ item.steadDept ? item.steadDept : '-' }}</span></td>
                    </tr>
                  </table>
                </div>
              </li>
            </div>

          </ol>
        </div>
      </div>
      <div v-else-if="totalCount < 1" class="girdNoData" style="text-align : center;">
        <div class="tab-content cmdp_box_list">
          표시할 데이터가 없습니다.
        </div>
      </div>
    </div>

    <!-- 페이징 -->
    <kendo-pager
        ref="pagingRef"
        :data-source="receptionStatusDataSource"
        :input="false"
        :page-sizes="false"
    >
    </kendo-pager>
  </section>
</template>

<script>
import EtnersParseUtil from "@/common/etners.parse.util";
import ApiConfig from "@/api/api.config";

import { Pager } from "@progress/kendo-listview-vue-wrapper";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";
import $ from "jquery";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import app from '@/main';

export default {
  name: "ReceptionStatus",
  components: {
    "kendo-pager": Pager,
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  created() {
    const vm = this
    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    vm.lastRouteParams = (sessionStorage.getItem('LAST_ROUTE_NAME') === 'SendDetail' || sessionStorage.getItem('LAST_ROUTE_NAME') === 'ReceiveDetail')
        ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []

    vm.tabSearch = {
      status: vm.lastRouteParams.status,
      sendReceiveGbn: vm.lastRouteParams.sendReceiveGbn,
    }

    vm.getReceptionStatus()
  },
  mounted () {
    const vm = this

    // 사업장 기본값 세팅
    vm.$refs.facilityRef.kendoWidget().value(vm.loginUserData.facility)
    // 거점(2Depth) 세팅
    vm.onChange1Depth('facilityRef')
    vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'steadNm'
    ]

    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
    // 거점 검색 세팅
    vm.lastRouteParams.areaList = vm.lastRouteParams.areaList
    if (vm.$refs.areaRef !== undefined) {
      vm.searchAreaTextList = this.$refs.areaRef.kendoWidget().dataItems()
    }
    vm.receptionStatusDataSource.read();
    vm.$refs.frstRgstDtEndDtRef.kendoWidget().value(vm.maxDate)
  },
  computed: {
    computedTabSearch () {
      const vm = this
      let tabSearch = vm.tabSearch

      if ((tabSearch.status === null || tabSearch.status === undefined) && tabSearch.sendReceiveGbn === '수령') {
        return '수령'
      } else if ((tabSearch.status === null || tabSearch.status === undefined) && tabSearch.sendReceiveGbn === '발송') {
        return '발송'
      } else if (tabSearch.status === '99' && (tabSearch.sendReceiveGbn === null || tabSearch.sendReceiveGbn === undefined)) {
        return '완료'
      } else if ((tabSearch.status === null || tabSearch.status === undefined) && (tabSearch.sendReceiveGbn === null || tabSearch.sendReceiveGbn === undefined)) {
        return '전체'
      }
      return '전체'
    }
  },
  methods: {

    setAutoRender() {
      const vm = this
      vm.autoRender = !vm.autoRender
      if (vm.autoRender) {
        vm.intervalSetting = window.setInterval(() => {
              vm.commonOnChangeEvent()
              vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
            }, 30000 //30초
        )
      } else {
        window.clearInterval(vm.intervalSetting);
      }
    },

    onChangeArea () {
      const vm = this
      const refs = vm.$refs

      if (refs.areaRef !== undefined && refs.areaRef !== null) {
        const dataItems = refs.areaRef.kendoWidget().dataItems()

        vm.searchAreaTextList = dataItems
      }
    },

    onChangeFacility () {
      const vm = this

      // 거점(2Depth) 세팅
      vm.onChange1Depth('facilityRef')

      // 사업장 검색 초기화
      vm.searchAreaTextList = []
      vm.searchAreaList = []
      vm.$refs.areaRef.kendoWidget().value('')

      vm.commonOnChangeEvent()
    },

    getReceptionStatus () {
      const vm = this
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      vm.receptionStatusDataSource = new kendo.data.DataSource({
        name: 'receptionStatusDataSource',
        page: lastRequestParameterPage,
        pageSize: 12,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/receptionStatus.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function(options, operation) {
            // 로딩 시작
            app.$Progress.plus()

            if (operation === 'read') {

              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: 0,
                take: 12,
                page: options.page,
                pageSize: 12,
                lastRenderingTime: vm.lastRenderingTime,
                frstRgstDtStartDt: paramToKendoFilters.frstRgstDtStartDt,
                frstRgstDtEndDt: paramToKendoFilters.frstRgstDtEndDt,
                facility: paramToKendoFilters.facility,
                areaList: paramToKendoFilters.areaList,
                sendReceiveGbn: paramToKendoFilters.sendReceiveGbn,
                status: paramToKendoFilters.status,
                // containSuccessYn: paramToKendoFilters.containSuccessYn,
                steadNm: paramToKendoFilters.steadNm,
                requestType: 'PAGING', // PAGING or EXPORT
              }

              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }

            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }

            const changeResultData = response.resultData

            if (changeResultData === null) {
              return false
            }

            //status 상태 값 받아오기
            response.resultData = changeResultData
            vm.receptionStatusList = changeResultData.receptionInfoList
            vm.totalCount = changeResultData.total
            vm.receptionEtcInfo = changeResultData.receptionEtcInfo

            // 로딩뉴 종료
            app.$Progress.minus()

            // 업데이트 알람 여부 확인
            // if (vm.receptionEtcInfo.newReceptionCount > 0) {
            //   kendo.alert(`${vm.receptionEtcInfo.newReceptionCount}건의 새로운 데이터가 존재합니다.`)
            //
            //   // 페이지에 들어오자마자 자동 재생하는 오디오를 차단하는 정책이 있다.
            //   // '똥-' 하는 음성 파일
            //   // let sound = "http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3"
            //   // let audio = new Audio(sound);
            //   // audio.play();
            // }

            return response
          },

          total: function(response) {
            return response.resultData.total
          },

          data: function(response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              const now = new Date()
              vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now)

              return response.resultData.receptionInfoList
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function(e) {
          // console.log('error event handler', e.errors)
        }
      })

    },

    currentPageFilterOption () {
      const vm = this
      const refs = vm.$refs
      const currentSearchDataObj = {}

      // 시작일
      if(refs.frstRgstDtStartDtRef !== undefined){
        const frstRgstDtStartDt = refs.frstRgstDtStartDtRef.kendoWidget().value()
        if(frstRgstDtStartDt !== null && frstRgstDtStartDt !== ''){
          currentSearchDataObj.frstRgstDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtStartDt, '')
        }
      }

      // 종료일
      if(refs.frstRgstDtEndDtRef !== undefined){
        const frstRgstDtEndDt = refs.frstRgstDtEndDtRef.kendoWidget().value()
        if(frstRgstDtEndDt !== null && frstRgstDtEndDt !== ''){
          currentSearchDataObj.frstRgstDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtEndDt, '')
        }
      }

      // 사업장
      if(refs.facilityRef !== undefined) {
        const facility = refs.facilityRef.kendoWidget().value()
        if(facility !== null && facility !== ''){
          currentSearchDataObj.facility = facility
        }
      }

      // 거점
      currentSearchDataObj.areaList = vm.$refs.areaRef.kendoWidget().value()

      // 수령인/발송인
      if (refs.steadNmRef !== undefined) {
        const steadNm = refs.steadNmRef.kendoWidget().value()
        if (steadNm !== null && steadNm !== '') {
          currentSearchDataObj.steadNm = steadNm.trim()
        }
      }

      // 탭 값 & 체크 박스
      currentSearchDataObj.sendReceiveGbn = vm.tabSearch.sendReceiveGbn
      currentSearchDataObj.status = vm.tabSearch.status

      return currentSearchDataObj
    },

    onChangeTab (value) {
      const vm = this
      let tabSearch = vm.tabSearch

      if (value === '수령') {
        tabSearch.status = null
        tabSearch.sendReceiveGbn = '수령'
      } else if (value === '발송') {
        tabSearch.status = null
        tabSearch.sendReceiveGbn = '발송'
      } else if (value === '완료') {
        tabSearch.status = '99'
        tabSearch.sendReceiveGbn = null
      } else {
        tabSearch.status = null
        tabSearch.sendReceiveGbn = null
      }

      vm.tabSearch = tabSearch
      vm.commonOnChangeEvent()
    },

    commonOnChangeEvent () {
      // 페이지 초기화
      const vm = this
      vm.receptionStatusDataSource.page(1)
    },

    clearFilter () {
      const vm = this
      const refs = vm.$refs

      // 등록일
      if (refs.frstRgstDtStartDtRef !== undefined && refs.frstRgstDtStartDtRef !== null) {
        refs.frstRgstDtStartDtRef.kendoWidget().value(0)
      }
      if (refs.frstRgstDtEndDtRef !== undefined && refs.frstRgstDtEndDtRef !== null) {
        refs.frstRgstDtEndDtRef.kendoWidget().value(0)
      }
      // 사업장
      if (refs.facilityRef !== undefined && refs.facilityRef !== null) {
        refs.facilityRef.kendoWidget().value([])
      }
      // 거점
      if (refs.areaRef !== undefined && refs.areaRef !== null) {
        refs.areaRef.kendoWidget().value('')

        // 거점 검색 리스트 초기화
        vm.onChangeFacility()
      }
      // 수령인/발송인
      if (refs.steadNmRef !== undefined && refs.steadNmRef !== null) {
        refs.steadNmRef.kendoWidget().value('')
      }
      // tab 검색
      vm.tabSearch.status = null
      vm.tabSearch.sendReceiveGbn = null

      vm.commonOnChangeEvent()
    },

    redirectToDetail (sendReceiveGbn, sendReceiveId) {
      const vm = this

      if (sendReceiveGbn === '수령') {
        vm.$router.push({
          name: 'ReceiveDetail',
          params: {
            receiveId: sendReceiveId
          }
        })
      } else if (sendReceiveGbn === '발송') {
        vm.$router.push({
          name: 'SendDetail',
          params: {
            sendId: sendReceiveId
          }
        })
      }
    },
  },
  data () {
    const now = new Date()
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      lastRouteParams : [],

      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),
      intervalSetting: undefined,
      autoRender: false,

      receptionStatusList: [],
      receptionStatusDataSource: [],
      totalCount : 0,
      receptionEtcInfo : {},

      searchAreaList: [],
      searchAreaTextList: [],
      tabSearchData : ['전체', '수령', '발송', '완료'],
      tabSearch: {
        sendReceiveGbn: null,
        status: null,
      },
      maxDate : now,
    }
  }
}
</script>

<style scoped>

</style>
